import i18n from "../i18n";
import { buttonText } from "./buttonText";
import {
  traditionalChineseNotificationPatterns,
  traditionalChineseNotificationText,
} from "../locales/notificationTranslations";

const installedTargets = new WeakSet();

function normalizeMessage(value) {
  if (typeof value === "string") return value;
  if (value instanceof Error) return value.message;
  if (value == null) return "";
  try {
    return typeof value === "object" ? JSON.stringify(value) : String(value);
  } catch {
    return String(value);
  }
}

function localizedFallback(value) {
  if (/success|succeed|completed|created|submitted|saved|loaded/i.test(value)) {
    return `操作成功。詳細資訊：${value}`;
  }
  if (/error|fail|invalid|missing|denied|unauthor|forbidden|cannot|can not|not |no /i.test(value)) {
    return `操作失敗。詳細資訊：${value}`;
  }
  return `系統通知：${value}`;
}

export function notificationText(value) {
  const message = normalizeMessage(value);
  if ((i18n.resolvedLanguage || i18n.language) !== "zh-TW" || !message) {
    return message;
  }

  const directTranslation = traditionalChineseNotificationText[message];
  if (directTranslation) return directTranslation;

  const pattern = traditionalChineseNotificationPatterns.find(([source]) =>
    source.test(message)
  );
  if (pattern) return message.replace(pattern[0], pattern[1]);

  const buttonTranslation = buttonText(message);
  if (buttonTranslation !== message) return buttonTranslation;

  if (/\p{Script=Han}/u.test(message)) return message;
  return localizedFallback(message);
}

export function installLocalizedDialogs(target = window) {
  if (!target || installedTargets.has(target)) return;

  const nativeAlert = target.alert?.bind(target);
  const nativeConfirm = target.confirm?.bind(target);
  if (nativeAlert) {
    target.alert = (message) => nativeAlert(notificationText(message));
  }
  if (nativeConfirm) {
    target.confirm = (message) => nativeConfirm(notificationText(message));
  }
  installedTargets.add(target);
}
